// src/sections/Admin/AdminLogin.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiLogIn, FiUser, FiLock, FiEye, FiEyeOff, FiMail } from 'react-icons/fi';
import './AdminLogin.css';

const AdminLogin = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
    setError(''); // مسح الخطأ عند البدء في الكتابة
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('https://taamirnajd.com/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          email: credentials.email,
          password: credentials.password
        })
      });

      const data = await response.json();

      if (response.ok) {
        // تخزين token ومعلومات المستخدم
        localStorage.setItem('adminToken', data.token);
        localStorage.setItem('adminUser', JSON.stringify(data.user));
        localStorage.setItem('adminAuthenticated', 'true');
        
        navigate('/admin-m3lomgy215-frontend-backend-taamernajd');
      } else {
        // عرض رسالة الخطأ من الخادم
        setError(data.message || t('adminLogin.invalidCredentials'));
      }
    } catch (error) {
      console.error('Login error:', error);
      setError(t('adminLogin.networkError'));
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="login-header">
          <div className="login-icon">
            <FiLogIn />
          </div>
          <h1>{t('adminLogin.title')}</h1>
          <p>{t('adminLogin.subtitle')}</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">
              <FiMail className="input-icon" />
              {t('adminLogin.email')}
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={credentials.email}
              onChange={handleInputChange}
              placeholder={t('adminLogin.emailPlaceholder')}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              <FiLock className="input-icon" />
              {t('adminLogin.password')}
            </label>
            <div className="password-input-container">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                value={credentials.password}
                onChange={handleInputChange}
                placeholder={t('adminLogin.passwordPlaceholder')}
                required
                disabled={loading}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={togglePasswordVisibility}
                disabled={loading}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={loading || !credentials.email || !credentials.password}
          >
            {loading ? (
              <div className="loading-spinner"></div>
            ) : (
              <>
                <FiLogIn />
                {t('adminLogin.loginButton')}
              </>
            )}
          </button>
        </form>

      </div>
    </div>
  );
};

export default AdminLogin;